/**
 * Utilities for checking client-side environment variables related to the build deployment environment. These vars are defined in SSM and are injected to the app FE at build time.
 */
import { z } from 'zod'

export const DeploymentEnvSchema = z.enum(['prd', 'stg', 'tst', 'dev', 'local'])

export type DeploymentEnv = z.infer<typeof DeploymentEnvSchema>

export const getClientDeploymentEnv = (): DeploymentEnv => {
  const maybeDeploymentEnv = DeploymentEnvSchema.safeParse(process.env.NEXT_PUBLIC_DEPLOYMENT)
  if (maybeDeploymentEnv.success) {
    return maybeDeploymentEnv.data
  }

  return 'local'
}

export const isClientDeploymentEnv = (env: DeploymentEnv | Array<DeploymentEnv>) => {
  const envsToCheck = Array.isArray(env) ? env : [env]
  const currentEnv = getClientDeploymentEnv()
  return envsToCheck.includes(currentEnv)
}
